export class RegionService {
  constructor($http) {
    this.http = $http;
  }

  getRegionsList(){
    return this.http.get('/api/region');
  }
}
